import AppRoutes from "@/routes/Routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

const queryClient = new QueryClient();
export { queryClient };

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <AppRoutes />
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              background: "rgb(32, 66, 102)",
              color: "#ffffff",
              border: "none",
              borderRadius: "0.5rem",
              fontSize: "0.875rem",
              fontWeight: "500",
              padding: "16px 20px",
            },
          }}
        />
      </div>
    </QueryClientProvider>
  );
}

export default App;
